export default "__VITE_ASSET__b25a27e0__"